import Callout from "ds/components/Callout";
import Markdown from "components/markdown/Markdown";
import useTypedFlags from "hooks/useTypedFlags";

import styles from "./styles.module.css";

const GlobalCallout = () => {
  const { feGlobalCallout } = useTypedFlags();

  if (!feGlobalCallout) return null;

  const { id, variant, title, description, dismissible } = feGlobalCallout;
  const storageKey = dismissible ? `fe-global-callout:${id}` : undefined;

  return (
    <Callout variant={variant} title={title} storageKey={storageKey}>
      <Markdown markup={description} openLinksInNewTab className={styles.markdown} />
    </Callout>
  );
};

export default GlobalCallout;
